<script setup>
import inputProps from "@/props/DefaultInputProps.js";
import { defineProps } from "vue";

const props = defineProps(inputProps);
</script>

<template>
  <div class="input-field">
    <label :for="props.id" :style="props.styles.inputLabel">{{
      props.label
    }}</label>
    <input
      :id="props.id"
      :type="props.type"
      :value="props.modelValue"
      :required="props.required"
      :minlength="props.minlength"
      :title="props.title"
      :style="props.styles.input"
      class="form-control"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>
